
















































import Vue from "vue";
import { mapState, mapGetters } from "vuex";

import TestCaseEditDialog from "@/components/TestCaseEditDialog.vue";
import TestSuits from "@/views/TestSuits.vue";

export default Vue.extend({
  components: {
    TestSuits,
    TestCaseEditDialog
  },
  data() {
    return {
      showDetailsFor: null,
      search: "",
      headers: [
        {
          text: "Title",
          value: "attrs.title"
        },
        {
          text: "Description",
          value: "attrs.description"
        },
        {
          text: "Steps #",
          value: "steps"
        },
        {
          text: "",
          value: "actions",
          width: "1"
        }
      ]
    };
  },
  computed: {
    ...mapState(["currentSuit"]),
    ...mapGetters({
      testCases: "testCasesForCurrentSuit"
    })
  },
  methods: {
    toggleDetailsFor(testCase: any) {
      if (this.showDetailsFor == testCase) {
        this.showDetailsFor = null;
      } else {
        this.showDetailsFor = testCase;
      }
    }
  }
});
